import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./GiftCards.module.scss";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
import { LinkType, Links } from "../Links/Links";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { formatGiftCardPrice } from "./formatGiftCardPrice";
export interface GiftCardItemProps {
  title: string;
  price?: number;
  image: SanityImageObject;
  alt?: string;
  links?: (LinkType | NavLink)[];
  locale?: string | null;
  currency?: string | null;
}
export const GiftCardItem: React.FC<GiftCardItemProps> = t0 => {
  const $ = _c(18);
  const {
    title,
    price,
    image,
    alt,
    links,
    locale,
    currency
  } = t0;
  const t1 = alt || title;
  let t2;
  if ($[0] !== image || $[1] !== t1) {
    t2 = <div className={styles.giftcarditemimage}><ResponsiveImage image={image} alt={t1} layout="cover" coverAspectRatio={1} sizes="(min-width: 1181px) 25vw, 90vw" /></div>;
    $[0] = image;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = <h3>{title}</h3>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== currency || $[6] !== locale || $[7] !== price) {
    t4 = price != null && <p className={styles.giftcarditemprice}>{formatGiftCardPrice(price, locale, currency)}</p>;
    $[5] = currency;
    $[6] = locale;
    $[7] = price;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className={styles.giftcarditemtext}>{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== links) {
    t6 = links && <Links links={links} buttons={true} />;
    $[12] = links;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className={styles.giftcarditem}>{t2}{t5}{t6}</div>;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};